/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync>): BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync(), model);
        BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync>): BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync.newInstance(<BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
